import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageWithLoaderComponent } from '../components/image-with-loader/image-with-loader.component';
import { InfoCardComponent } from '../components/info-card/info-card.component';
import { layouts } from './image-tiles.constants';
import { ImageTile, CmsFile, ButtonLink, M2A } from 'www-cms';
import { BaseBuildingBlockComponent } from '../components/base-building-block.component';
import { LastItemBgClass } from '../../shell/shell.service';
import { ButtonLinkComponent } from 'building-blocks/button-link/button-link.component';
import { DirectusDirective } from 'directus';

@Component({
  selector: 'ss-www-image-tiles',
  imports: [
    CommonModule,
    ImageWithLoaderComponent,
    InfoCardComponent,
    ButtonLinkComponent,
    DirectusDirective,
  ],
  templateUrl: './image-tiles.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageTilesComponent extends BaseBuildingBlockComponent {
  @Input({ required: true }) imageTileData!: Partial<ImageTile>;
  layouts = layouts;
  imageTrackByFn(index: number, item: CmsFile) {
    return item.directus_files_id;
  }

  buttonTrackByFn(index: number, item: M2A<ButtonLink>) {
    return item.id;
  }

  getBgClass(): LastItemBgClass {
    return this.imageTileData.darkBackground
      ? 'bg-ss-www-background'
      : 'bg-white';
  }
}
